module.exports = __webpack_public_path__ + "static/img/banners.2c195411.png";